// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na.disabled[data-v-b56e2694] {\n  pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
